export const totalHours = 19;
